module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-desktop is-tablet"
  }, [_c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('article', {
    staticClass: "media"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('profile')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-tablet"
  }, [_c('profile')], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('gmap')], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 20px 0 20px"
    }
  }, [_c('lessons'), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left m-t-20"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/dai-hua.jpg"),
      "alt": "Dai Hua"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-hidden-tablet"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/dai-hua.jpg"),
      "alt": "Dai Hua"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h3', [_vm._v("Source: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.irs.gov/businesses/small-businesses-self-employed/arizona-tax-workshops-meetings-and-seminars",
      "target": "_blank"
    }
  }, [_vm._v("IRS Tax Workshops, Meetings and Seminars")])]), _vm._v(" "), _c('h3', [_vm._v("Register for classes at: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series",
      "target": "_blank"
    }
  }, [_vm._v("Phoenix Library Website")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e67d688","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 509
// module chunks = 1